<template>
  <div>
    <PageAllow
      controller="Orders"
      :action="$route.path.startsWith('/orders-approve') ? 'approval' : 'index'"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <!-- <v-sheet
        id="fix-header"
        v-resize="$mainResizer"
        :class="
          ($vuetify.rtl ? 'fix-header-rtl ' : 'fix-header ') +
          (mainContentScrolled ? 'elevation-2' : 'transparent-background-color')
        "
      > -->
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                deleteIcon
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-col>
                <v-menu
                  v-if="
                    !$route.path.startsWith('/orders-') &&
                    ($permission.permissionAllow('Orders', 'import') ||
                      $permission.permissionAllow('Orders', 'buyerImport') ||
                      $permission.permissionAllow('Orders', 'otherImport'))
                  "
                  v-model="batchImportBtnMenu"
                  open-on-hover
                  close-on-click
                  close-on-content-click
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      color="print"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ms-1 float-end"
                    >
                      <v-icon x-small class="pe-1">fa-file-import</v-icon>
                      {{ $t("Order.actions.batchImport") }}
                      <v-icon x-small class="ps-1">
                        {{
                          batchImportBtnMenu ? "fa-caret-up" : "fa-caret-down"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <!-- 一言为订导入 -->
                    <v-list-item
                      @click.stop="
                        import_type = 1;
                        ImportDialog = true;
                      "
                      v-if="$permission.permissionAllow('Orders', 'import')"
                    >
                      <v-list-item-title>
                        {{ $t("Order.Import.yywd_import") }}
                      </v-list-item-title>
                    </v-list-item>
                    <!-- 一言为订导入(标配) -->
                    <v-list-item
                      @click.stop="
                        import_type = 4;
                        ImportDialog = true;
                      "
                      v-if="$permission.permissionAllow('Orders', 'import')"
                    >
                      <v-list-item-title>
                        {{ $t("Order.Import.yywd_import_auto") }}
                      </v-list-item-title>
                    </v-list-item>
                    <!-- 买家导入 -->
                    <v-list-item
                      @click.stop="
                        import_type = 2;
                        ImportByBuyerDialog = true;
                      "
                      v-if="
                        $permission.permissionAllow('Orders', 'buyerImport')
                      "
                    >
                      <v-list-item-title>
                        {{ $t("Order.Import.buyer_import") }}
                      </v-list-item-title>
                    </v-list-item>
                    <!-- 第三方导入 -->
                    <v-list-item
                      @click.stop="
                        import_type = 3;
                        ImportDialog = true;
                      "
                      v-if="
                        $permission.permissionAllow('Orders', 'otherImport')
                      "
                    >
                      <v-list-item-title>
                        {{ $t("Order.Import.other_import") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <!-- 导出 -->
                <v-menu
                  v-if="
                    (!$route.path.startsWith('/orders-') &&
                      $permission.permissionAllow(
                        'Orders',
                        'batchDetailExport'
                      )) ||
                    ($permission.permissionAllow('Orders', 'freightExport') &&
                      !$route.path.startsWith('/orders-'))
                  "
                  v-model="exportBtnMenu"
                  open-on-hover
                  close-on-click
                  close-on-content-click
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      color="print"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ms-1 float-end"
                    >
                      <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                      {{ $t("Order.actions.batchExports") }}
                      <v-icon x-small class="ps-1">
                        {{ exportBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <!-- 批量导出订单 -->
                    <v-list-item
                      v-if="
                        !$route.path.startsWith('/orders-') &&
                        $permission.permissionAllow(
                          'Orders',
                          'batchDetailExport'
                        )
                      "
                      @click.stop="batchExport()"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.batchExport") }}
                      </v-list-item-title>
                    </v-list-item>
                    <!-- 运费统计详情导出 -->
                    <v-list-item
                      v-if="
                        $permission.permissionAllow(
                          'Orders',
                          'freightExport'
                        ) && !$route.path.startsWith('/orders-')
                      "
                      @click.stop="freightExport()"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.freightExport") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <!-- 批量云打印 -->
                <v-menu
                  v-if="
                    !$route.path.startsWith('/orders-') &&
                    ($permission.permissionAllow(
                      'Orders',
                      'ordersToDistributionsPrint'
                    ) ||
                      $permission.permissionAllow('Orders', 'ordersPrint')) &&
                    $permission.permissionAllow('CloudPrints', 'index') &&
                    settings &&
                    settings.cloud_print_enable
                  "
                  v-model="cloudPrintBtnMenu"
                  open-on-hover
                  close-on-click
                  close-on-content-click
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      color="print"
                      class="ms-1 float-end"
                      @click.stop=""
                    >
                      <v-icon x-small class="pe-1">fa-print</v-icon>
                      {{ $t("Print.batch_cloud_print") }}
                      <v-icon x-small class="ps-1">
                        {{
                          cloudPrintBtnMenu ? "fa-caret-up" : "fa-caret-down"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-if="
                        $permission.permissionAllow(
                          'Orders',
                          'ordersToDistributionsPrint'
                        )
                      "
                      @click.stop="doCloudPrint('distribution')"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.batchDistributionPrint") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        $permission.permissionAllow('Orders', 'ordersPrint')
                      "
                      @click.stop="doCloudPrint('order')"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.ordersPrint") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu
                  v-if="
                    !$route.path.startsWith('/orders-') &&
                    ($permission.permissionAllow(
                      'Orders',
                      'ordersToDistributionsPrint'
                    ) ||
                      $permission.permissionAllow('Orders', 'ordersPrint'))
                  "
                  v-model="printBtnMenu"
                  open-on-hover
                  close-on-click
                  close-on-content-click
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      color="print"
                      class="ms-1 float-end"
                      @click.stop=""
                    >
                      <v-icon x-small class="pe-1">fa-print</v-icon>
                      {{ $t("Print.batchPrint") }}
                      <v-icon x-small class="ps-1">
                        {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-if="
                        $permission.permissionAllow(
                          'Orders',
                          'ordersToDistributionsPrint'
                        )
                      "
                      @click.stop="doPrint('distributionPrint')"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.batchDistributionPrint") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        $permission.permissionAllow('Orders', 'ordersPrint')
                      "
                      @click.stop="doPrint('OrdersPrint')"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.ordersPrint") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn
                  v-if="
                    !$route.path.startsWith('/orders-') &&
                    $permission.permissionAllow('Orders', 'add')
                  "
                  small
                  color="primary"
                  href="/#/order-new"
                  class="ms-1 float-end"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("CRUD.newInfo", [$t("Order.ObjectName")]) }}
                </v-btn>
                <!-- <v-btn
                  v-if="
                    !$route.path.startsWith('/orders-') &&
                    $permission.permissionAllow('Orders', 'batchConfirm')
                  "
                  small
                  color="accent"
                  class="ms-1 float-end"
                  @click="batchConfirmDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                  {{ $t("Order.actions.batchConfirm") }}
                </v-btn> -->
                <v-menu
                  v-if="
                    !$route.path.startsWith('/orders-') &&
                    ($permission.permissionAllow('Orders', 'batchConfirm') ||
                      $permission.permissionAllow('Orders', 'batchCancel'))
                  "
                  v-model="confirmBtnMenu"
                  open-on-hover
                  close-on-click
                  close-on-content-click
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      color="orange"
                      class="ms-1 float-end"
                      @click.stop=""
                    >
                      <v-icon x-small class="pe-1">fa-print</v-icon>
                      {{ $t("Order.actions.batchConfirm") }}
                      <v-icon x-small class="ps-1">
                        {{ confirmBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <!-- 批量确认 -->
                    <v-list-item
                      v-if="
                        $permission.permissionAllow('Orders', 'batchConfirm')
                      "
                      @click="batchConfirmDialog = true"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.batchConfirm") }}
                      </v-list-item-title>
                    </v-list-item>
                    <!-- 批量作废 -->
                    <v-list-item
                      v-if="
                        $permission.permissionAllow('Orders', 'batchCancel')
                      "
                      @click="batchCancelDialog = true"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.batchCancel") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu
                  v-if="
                    $route.path.startsWith('/orders-approve') &&
                    ($permission.permissionAllow('Orders', 'batchApprove') ||
                      $permission.permissionAllow('Orders', 'batchCancel'))
                  "
                  v-model="approveBtnMenu"
                  open-on-hover
                  close-on-click
                  close-on-content-click
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      color="orange"
                      class="ms-1 float-end"
                      @click.stop=""
                    >
                      <v-icon x-small class="pe-1">fa-print</v-icon>
                      {{ $t("Order.actions.batchConfirm") }}
                      <v-icon x-small class="ps-1">
                        {{ approveBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <!-- 批量通过 -->
                    <v-list-item
                      v-if="
                        $permission.permissionAllow('Orders', 'batchApprove')
                      "
                      @click="batchApproveDialog = true"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.batchApprove") }}
                      </v-list-item-title>
                    </v-list-item>
                    <!-- 批量作废 -->
                    <v-list-item
                      v-if="
                        $permission.permissionAllow('Orders', 'batchCancel')
                      "
                      @click="batchCancelDialog = true"
                    >
                      <v-list-item-title>
                        {{ $t("Order.actions.batchCancel") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <!-- <v-btn
                  v-if="
                    $route.path.startsWith('/orders-approve') &&
                    $permission.permissionAllow('Orders', 'batchApprove')
                  "
                  small
                  color="accent"
                  class="ms-1 float-end"
                  @click="batchApproveDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                  {{ $t("Order.actions.batchApprove") }}
                </v-btn> -->
                <!-- <v-btn
                  v-if="$permission.permissionAllow('Orders', 'batchCancel')"
                  small
                  color="accent"
                  class="ms-1 float-end"
                  @click="batchCancelDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                  {{ $t("Order.actions.batchCancel") }}
                </v-btn> -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="orderCodeKeyword = $event"
                    :label="$t('Order.Fields.order_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="ext_code"
                    v-model="options.ext_code"
                    @text="extCodeKeyword = $event"
                    :label="$t('Order.Fields.ext_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherOrderOriginFlgs v-model="options.origin_flgs" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials v-model="materialSelected" />
                </v-col>
<!--                <v-col cols="12" sm="6" md="4">-->
<!--                  <SearcherShops v-model="shopsSelected" />-->
<!--                </v-col>-->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                   ref="shop_keyword"
                   v-model="options.shop_keyword"
                   @text="shopKeyword = $event"
                   :label="$consts.shopName()"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants
                    v-model="districtSelected"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    $permission.permissionAllow('AllianceBusinesses', 'index')
                  "
                >
                  <SearcherAlliances v-model="alliancesSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-if="!$route.path.startsWith('/orders-approve')"
                    v-model="options.status"
                    :label="$t('Order.status.title')"
                    :items="$consts.order.status"
                  />
                  <v-sheet v-else class="transparent-background-color">
                    <div
                      class="caption grey--text input-chip-group-label"
                      :class="
                        $vuetify.theme.dark
                          ? 'text--lighten-1'
                          : 'text--darken-1'
                      "
                    >
                      {{ $t("Order.grantedStatus.title") }}
                    </div>
                    <v-chip-group v-model="grantedStatus" column multiple>
                      <v-chip
                        small
                        label
                        filter
                        class="me-1"
                        color="accent"
                        :value="0"
                      >
                        {{ $t("Order.grantedStatus.confirmed") }}
                      </v-chip>
                      <v-chip
                        small
                        label
                        filter
                        class="me-1"
                        color="primary"
                        :value="1"
                      >
                        {{ $t("Order.grantedStatus.granted") }}
                      </v-chip>
                    </v-chip-group>
                  </v-sheet>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.pay_flgs"
                    :items="$consts.bill.pay_flgs"
                    :label="$t('Bill.payFlgs.title')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherCancelFlgs v-model="options.cancel_flgs" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.error_flg"
                    :label="$t('Order.error_flg.title')"
                    :items="$consts.order.error_flg"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    $permission.permissionAllow('PresaleTemplates', 'index') &&
                    settings &&
                    settings.presale_enable
                  "
                >
                  <SearcherStatus
                    v-model="options.presale_flgs"
                    :label="$t('Order.presale_flgs.title')"
                    :items="$consts.order.presale_flg"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <!-- <div
        class="mx-4 mb-4"
        :style="'padding-top: ' + fixHeaderHeightInPx + 'px'"
      > -->
      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="(settings && settings.order_index_express_display) ? orderItems : orders"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.shop>
            {{ $consts.shopName() }}
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              v-if="options.datetimeRadioSelected == 'created'"
            >
              {{ item.created | formatTime }}
            </span>
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              v-if="options.datetimeRadioSelected == 'actual'"
            >
              {{ item.actual_date | formatTime }}
            </span>
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              v-if="options.datetimeRadioSelected == 'expect'"
            >
              {{ item.expect_date | formatTime }}
            </span>
          </template>
          <template v-slot:item.shop.shop_name="{ item }">
            <span class="text-no-wrap">
              {{ item.shop.shop_name }}
            </span>
            <br />
            <span class="text-no-wrap caption secondary--text">
              {{ item.shop.shop_code }}
            </span>
          </template>
          <template v-slot:item.details_num_and_weight_total="{ item }">
            <span class="caption secondary--text text-no-wrap">
              {{
                $t("Order.Fields.details_num_unit", [
                  $numberFormatter.formatTwoDot(item.details_num),
                ])
              }}
            </span>
            <br />
            <span class="caption secondary--text text-no-wrap">
              {{
                $t("Order.Fields.weight_total_unit", [
                  $numberFormatter.formatTwoDot(item.weight_total),
                ])
              }}
            </span>
          </template>
          <template v-slot:item.order_price="{ item }">
            {{ $t("Global.money") }}{{ item.order_price | formatMoney }}
          </template>
          <template v-slot:item.express_price="{ item }">
            <span
              v-if="item.edit_express"
            >
              <v-text-field
                v-model="item.express_price"
                :placeholder="
                  String(
                    $numberFormatter.formatTwoDot(
                      item.express_price,
                      2
                    )
                  )
                "
                single-line
                dense
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.express_price =
                    item.express_price == ''
                      ? item.express_price
                        : $numberFormatter.formatMoneyFloor(
                          item.express_price
                        )
                "
                @input="
                  item.order_price =
                    item.price_fix -
                    item.price_cut +
                    item.service_charge +
                    Number(item.express_price)
                "
                style="max-width: 80px; margin-left: auto"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="saveExpress(item)"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-check
                  </v-icon>
                </template>
              </v-text-field>
            </span>
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.express_price | formatMoneyFloor }}
              <v-icon
                v-if="
                  !item.edit_express &&
                  settings &&
                  (!settings.paid_close_order_fee ||
                  (settings.paid_close_order_fee &&
                  item.bill &&
                  item.bill.pay_flg == 1))
                "
                x-small
                color="primary"
                class=""
                style="display: inline-block"
                @click.stop="setEditExpressFlg(item)"
              >fa-pencil-alt
              </v-icon>
            </span>
          </template>
          <template v-slot:item.expect_date="{ item }">
            <span class="caption secondary--text">
              {{ item.expect_date | formatTime }}
            </span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | orderStatusColor"
              :text-color="item.status | orderStatusTextColor"
              >{{ item.status | orderStatusText }}
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg || item.error_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{
                item.cancel_flg
                  ? $t("CRUD.cancelled")
                  : $t("Order.redeliverError")
              }}
            </v-chip>
          </template>
          <template v-slot:item.presale_flg="{ item }">
            <v-chip
              small
              label
              :color="item.presale_flg | presaleFlgsColor"
              :text-color="item.presale_flg | presaleFlgsTextColor"
              >{{ item.presale_flg | presaleFlgsText }}
            </v-chip>
          </template>
          <template v-slot:item.bill.pay_flg="{ item }">
            <span class="text-no-wrap">
              <v-chip
                small
                label
                :color="item.bill.pay_flg | billPayFlgsColor"
                :text-color="item.bill.pay_flg | billPayFlgsTextColor"
                >{{ item.bill.pay_flg | billPayFlgsText }}
              </v-chip>
              <v-chip
                small
                label
                class="d-none ms-1"
                :color="item.bill.status | billStatusColor"
                :text-color="item.bill.status | billStatusTextColor"
                >{{ item.bill.status | billStatusText }}
              </v-chip>
            </span>
          </template>
          <template v-slot:item.origin_flg="{ item }">
            <v-chip
              style="height: auto"
              small
              label
              :color="item.origin_flg | orderOriginFlgsColor"
              :text-color="item.origin_flg | orderOriginFlgsTextColor"
              >{{ item.origin_flg | orderOriginFlgsText }}<br />
              ({{ item.creater_name }})
            </v-chip>
          </template>
          <template v-slot:item.memo="{ item }">
            <v-tooltip right v-if="item.memo || item.account_memo">
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="d-block text-truncate"
                  style="max-width: 120px"
                  >
                  {{ item.memo }} <br /> {{ item.account_memo }}
                </span>
              </template>
              {{ item.memo }} <br /> {{ item.account_memo }}
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <OrderActions
              :order="item"
              showView
              :showEdit="!$route.path.startsWith('/orders-')"
              :showConfirm="!$route.path.startsWith('/orders-')"
              :showRedeliver="!$route.path.startsWith('/orders-')"
              :showApprove="$route.path.startsWith('/orders-approve')"
              showCancel
              showRevokeCancel
              :showExport="!$route.path.startsWith('/orders-')"
              :showPrint="!$route.path.startsWith('/orders-')"
              :showCloudPrint="
                (!$route.path.startsWith('/orders-') &&
                $permission.permissionAllow('CloudPrints', 'index') &&
                settings &&
                settings.cloud_print_enable) ? true : false
              "
              @done="getOrdersFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <!-- 订单导入 -->
    <ImportExcelAlert
      v-model="ImportDialog"
      :title="
        import_type == 1
          ? $t('Order.Import.yywd_import')
          : import_type == 3
          ? $t('Order.Import.other_import')
          : import_type == 4
          ? $t('Order.Import.yywd_import_auto')
          : ''
      "
      :objName="$t('Order.ObjectName')"
      :downloadTemplateUrl="
        import_type == 1 || import_type == 4
          ? settings && settings.presale_enable
            ? 'download/template/pre_order_template.xls'
            : 'download/template/order_template.xls'
          : import_type == 3
          ? 'download/template/order_baiguoyuan_template.xls'
          : ''
      "
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportOrdersResultDialog
      v-model="ImportOrdersResultDialog"
      :errorOrders="errorOrders"
    />
    <ImportExcelByBuyerAlert
      v-model="ImportByBuyerDialog"
      :objName="$t('Order.ObjectName')"
      downloadTemplateUrl="download/template/order_template_buyer.xls"
      @import="
        excelByBuyerFile = $event;
        importExcel();
      "
      @selectedShop="selectShop = $event"
    />

    <!-- 批量确认 -->
    <DialogAlert
      v-model="batchConfirmDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Order.messages.batchConfirmAlert')"
      persistent
      useConfirm
      @confirm="
        batchConfirmDialog = false;
        batchConfirmingInfoDialog = true;
        batchConfirm(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchConfirmingInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchConfirmingInfo"
      persistent
      :closable="errorCount > 0"
    />
    <!-- 批量作废 -->
    <DialogAlert
      v-model="batchCancelDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Order.messages.batchCancelAlert')"
      persistent
      useConfirm
      @confirm="
        batchCancelDialog = false;
        batchCancelInfoDialog = true;
        batchCancel(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchCancelInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchCancelInfo"
      persistent
      :closable="errorCount > 0"
    />
    <!-- 批量通过 -->
    <DialogAlert
      v-model="batchApproveDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Order.messages.batchApproveAlert')"
      persistent
      useConfirm
      @confirm="
        batchApproveDialog = false;
        batchApproveInfoDialog = true;
        batchApprove(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchApproveInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchApproveInfo"
      persistent
      :closable="errorCount > 0"
    />
    <!-- 批量通过错误提示 -->
    <BatchApproveErrorAlert
      v-model="batchApproveErrorDialog"
      :Items="batchApproveErrorData"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherOrderOriginFlgs from "@/components/plugins/SearcherOrderOriginFlgs";
// import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import ImportOrdersResultDialog from "./plugins/ImportOrdersResultDialog";
import ImportExcelByBuyerAlert from "./plugins/ImportExcelByBuyerAlert";
import DialogAlert from "@/components/plugins/DialogAlert";
import BatchOperationInfoAlert from "./plugins/BatchOperationInfoAlert";
import OrderActions from "./plugins/Actions";
import Orders from "@/api/orders";
import BatchApproveErrorAlert from "./plugins/BatchApproveErrorAlert";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import makeData from "../distributions/makeData";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime())
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  order_code: "",
  ext_code: "",
  shop_keyword: "",
  origin_flgs: [],
  shop_ids: [],
  no_children_district_codes: [],
  alliance_business_ids: [],
  status: [1, 2, 3, 4, 5],
  pay_flgs: [1, 2, 3],
  presale_flgs: [0, 1],
  cancel_flgs: [0],
  sortBy: [],
  sortDesc: [],
  material_ids: [],
};

function getPageType() {
  return document.URL.endsWith("/orders-approve") ? 2 : 1;
}
function getOptionPrefix() {
  switch (getPageType()) {
    default:
    case 1:
      return "orders";
    case 2:
      return "orders-approve";
  }
}
function getDefaultOptions() {
  switch (getPageType()) {
    default:
    case 1:
    case 2:
      return defaultOptions;
  }
}

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherOrderOriginFlgs,
    // SearcherShops,
    SearcherDistrictsWithDescendants,
    SearcherAlliances,
    SearcherStatus,
    SearcherCancelFlgs,
    SearcherMaterials,
    OrderActions,
    ImportExcelAlert,
    ImportExcelByBuyerAlert,
    DialogAlert,
    BatchOperationInfoAlert,
    BatchApproveErrorAlert,
    ImportOrdersResultDialog,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderManagement"),
          disabled: false,
          replace: true,
          href: "/orders",
        },
      ];
      if (this.$route.path.startsWith("/orders-approve")) {
        items.push({
          text: i18n.t("Nav.ordersApprove"),
          disabled: true,
          href: "/orders-approve",
        });
      } else {
        items.push({
          text: i18n.t("Nav.orders"),
          disabled: true,
          href: "/orders",
        });
      }
      return items;
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Order.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("Order.Fields.actual_time"),
      },
      {
        key: "expect",
        text: i18n.t("Order.Fields.expect_date"),
      },
    ],
    headers() {
      let headers = [
        {
          text:
            i18n.t("Order.Fields.order_code") +
            " / " +
            this.datetimeRadios.find(
              (s) => s.key == this.options.datetimeRadioSelected
            ).text,
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("Order.Fields.shop", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop.shop_name",
        },
        // {
        //   text: i18n.t("Order.Fields.details_num_and_weight_total"),
        //   align: "end",
        //   sortable: false,
        //   class: "text-no-wrap",
        //   value: "details_num_and_weight_total",
        // },// 暂时不显示了
        {
          text: i18n.t("Order.Fields.order_price"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "order_price",
        },
      ];
      if (this.settings && this.settings.order_index_express_display) {
        headers.push(
          {
            text: i18n.t("Order.Fields.express_price"),
            align: "center",
            sortable: false,
            class: "text-no-wrap",
            width: 120,
            value: "express_price",
          }
        );
      }
      headers.push(
        {
          text: i18n.t("Order.Fields.expect_date"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "expect_date",
        },
        {
          text: i18n.t("Order.Fields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
      );
      if (
        this.$permission.permissionAllow("PresaleTemplates", "index") &&
        this.settings &&
        this.settings.presale_enable
      ) {
        headers.push({
          text: i18n.t("Order.Fields.presale_flg"),
          align: "center",
          sortable: false,
          value: "presale_flg",
        });
      }
      headers.push({
        text: i18n.t("Order.Fields.bill_pay_flgs"),
        // + " / " + i18n.t("Order.Fields.bill_status"),
        align: "center",
        sortable: false,
        value: "bill.pay_flg",
      });
      // v-if="(settings.order_memo_display && settings.order_memo_display != 2) || !settings.order_memo_display">

      headers.push({
        text: i18n.t("Order.Fields.order_memo"),
        align: "start",
        sortable: false,
        width: 120,
        value: "memo",
      });

      // if (
      //   this.settings &&
      //   this.settings.order_memo_display &&
      //   this.settings.order_memo_display == 1
      // ) {
      //   headers.push({
      //     text: i18n.t("Order.Fields.account_memo"),
      //     align: "start",
      //     sortable: false,
      //     width: 120,
      //     value: "account_memo",
      //   });
      // } else if (
      //   this.settings &&
      //   this.settings.order_memo_display &&
      //   this.settings.order_memo_display == 2
      // ) {
      //   headers.push({
      //     text: i18n.t("Order.Fields.memo", [this.$consts.shopName()]),
      //     align: "start",
      //     sortable: false,
      //     width: 120,
      //     value: "memo",
      //   });
      // } else {
      //   headers.push(
      //     {
      //       text: i18n.t("Order.Fields.account_memo"),
      //       align: "start",
      //       sortable: false,
      //       width: 120,
      //       value: "account_memo",
      //     },
      //     {
      //       text: i18n.t("Order.Fields.memo", [this.$consts.shopName()]),
      //       align: "start",
      //       sortable: false,
      //       width: 120,
      //       value: "memo",
      //     }
      //   );
      // }
      headers.push(
        {
          text: i18n.t("Order.Fields.origin_flg"),
          align: "center",
          sortable: false,
          value: "origin_flg",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },
    orderItems() {
      return this.orders.map((order) => {
        if (this.editExpressData && order.id == this.editExpressData.id) {
          order.edit_express = 1;
        }else {
          order.edit_express = 0;
        }
        return order
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "loading",
      "stickTableCols",
      "mainContentScrolled",
      "fixHeaderHeightInPx",
      "settings",
      "accountInfo",
    ]),
  },

  data: () => ({
    orderCodeKeyword: "",
    extCodeKeyword: "",
    shopKeyword: "",
    shopsSelected: [],
    districtSelected: [],
    alliancesSelected: [],
    materialSelected: [],
    grantedStatus: [0],
    options: JSON.parse(
      sessionStorage.getItem(getOptionPrefix() + "-options")
        ? sessionStorage.getItem(getOptionPrefix() + "-options")
        : JSON.stringify(getDefaultOptions())
    ),
    batchImportBtnMenu: false,
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    paging: {},
    orders: [],
    ImportDialog: false,
    excelFile: null,
    selectShop: {},
    ImportByBuyerDialog: false,
    excelByBuyerFile: null,
    import_type: 0,
    errorCount: 0,
    successCount: 0,
    redeliverErrorCount: 0,
    error_order_id: [],
    unconfirmOrders: [],
    unconfirmOrderLength: 0,
    alreadyConfirmedOrderLength: 0,
    batchConfirmDialog: false,
    batchConfirmingInfoDialog: false,
    batchConfirmingInfo: i18n.t("Order.messages.batchConfirmingInfo", [0, 0]),
    cancelableOrders: [],
    cancelableOrderLength: 0,
    alreadyCanceledOrderLength: 0,
    batchCancelDialog: false,
    batchCancelInfoDialog: false,
    exportBtnMenu: false,
    confirmBtnMenu: false,
    approveBtnMenu: false,
    batchCancelInfo: i18n.t("Order.messages.batchCancelInfo", [0, 0]),
    approvableOrders: [],
    approvableOrderLength: 0,
    alreadyApprovedOrderLength: 0,
    batchApproveDialog: false,
    batchApproveInfoDialog: false,
    batchApproveInfo: i18n.t("Order.messages.batchCancelInfo", [0, 0]),
    batchApproveErrorDialog: false,
    batchApproveErrorData: [],
    errorOrders: [],
    ImportOrdersResultDialog: false,
    editExpressData: null,
  }),

  mounted() {
    this.$commonUtils
      .loadOptions(getOptionPrefix(), [
        "grantedStatus",
        "shopsSelected",
        "districtSelected",
        "alliancesSelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "grantedStatus":
                this.grantedStatus = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "districtSelected":
                this.districtSelected = selected.value;
                break;
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  watch: {
    $route() {
      this.$commonUtils
        .loadOptions(getOptionPrefix(), [
          "grantedStatus",
          "shopsSelected",
          "districtSelected",
          "alliancesSelected",
          "materialSelected",
        ])
        .then(
          function (data) {
            if (data.options) {
              this.options = data.options;
              if (
                typeof this.options.created_time_from != "undefined" &&
                typeof this.options.created_time_to != "undefined"
              )
                this.datetimeRage = [
                  this.options.created_time_from,
                  this.options.created_time_to,
                ];
            } else this.resetSearch();

            data.selecteds.forEach((selected) => {
              switch (selected.key) {
                case "grantedStatus":
                  this.grantedStatus = selected.value;
                  break;
                case "shopsSelected":
                  this.shopsSelected = selected.value;
                  break;
                case "districtSelected":
                  this.districtSelected = selected.value;
                  break;
                case "alliancesSelected":
                  this.alliancesSelected = selected.value;
                  break;
                case "materialSelected":
                  this.materialSelected = selected.value;
                  break;
              }
            });
          }.bind(this)
        );
    },
    grantedStatus: {
      handler() {
        this.getOrdersFromAPI();
        sessionStorage.setItem(
          getOptionPrefix() + "-grantedStatus",
          JSON.stringify(this.grantedStatus)
        );
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrdersFromAPI();
        sessionStorage.setItem(
          getOptionPrefix() + "-options",
          JSON.stringify(this.options)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((alliance) => {
              return alliance.id;
            })
          : [];
        sessionStorage.setItem(
          getOptionPrefix() + "-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    districtSelected: {
      handler() {
        this.options.no_children_district_codes = this.districtSelected
          ? this.districtSelected.map((e) => {
              return e.code;
            })
          : [];
        sessionStorage.setItem(
          getOptionPrefix() + "-districtSelected",
          JSON.stringify(this.districtSelected)
        );
      },
    },
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((alliance) => {
              return alliance.id;
            })
          : [];
        sessionStorage.setItem(
          getOptionPrefix() + "-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    ImportByBuyerDialog: {
      handler() {
        if (!this.ImportByBuyerDialog && this.selectShop) {
          this.selectShop = null;
        }
      },
    },
    batchApproveInfoDialog: {
      handler() {
        if (!this.batchApproveInfoDialog) {
          this.batchApproveErrorData = [];
        }
      },
    },
  },

  methods: {
    resetSearch() {
      this.shopsSelected = [];
      this.districtSelected = null;
      this.alliancesSelected = [];
      this.materialSelected = [];
      this.grantedStatus = [0];
      this.editExpressData = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.order_code, this.$refs.ext_code, this.$refs.shop_keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        order_code: this.orderCodeKeyword,
        ext_code: this.extCodeKeyword,
        shop_keyword: this.shopKeyword,
      });
    },
    getOrdersFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        //订单审批页需要替换状态参数
        this.$route.path.startsWith("/orders-approve") &&
        this.grantedStatus &&
        Array.isArray(this.grantedStatus)
      ) {
        var status = [];
        this.grantedStatus.forEach((value) => {
          switch (value) {
            case 0:
              status.push(2);
              break;
            case 1:
              status.push(3, 4, 5, 6);
              break;
          }
        });
        options.status = status;
      }
      this.editExpressData = null;
      if (getPageType() == 2) {
        Orders.approval(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.orders = response.data.orders;
              this.paging = response.data.paging;

              let unconfirmOrders = [];
              let cancelableOrders = [];
              let approvableOrders = [];
              this.orders.forEach((order) => {
                //取未审批的单子
                if (order.actions.confirm) {
                  unconfirmOrders.push(order);
                }
                //取可作废的单子
                if (order.actions.cancel) {
                  cancelableOrders.push(order);
                }
                //取可审批的单子
                if (order.actions.approve) {
                  approvableOrders.push(order);
                }
              });
              this.unconfirmOrders = unconfirmOrders;
              this.unconfirmOrderLength = unconfirmOrders.length;
              this.cancelableOrders = cancelableOrders;
              this.cancelableOrderLength = cancelableOrders.length;
              this.approvableOrders = approvableOrders;
              this.approvableOrderLength = approvableOrders.length;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
        );
      } else {
        Orders.fetch(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.orders = response.data.orders;
              this.paging = response.data.paging;

              let unconfirmOrders = [];
              let cancelableOrders = [];
              this.orders.forEach((order) => {
                //取未审批的单子
                if (order.actions.confirm) {
                  unconfirmOrders.push(order);
                }
                //取可作废的单子
                if (order.actions.cancel) {
                  cancelableOrders.push(order);
                }
              });
              this.unconfirmOrders = unconfirmOrders;
              this.unconfirmOrderLength = unconfirmOrders.length;
              this.cancelableOrders = cancelableOrders;
              this.cancelableOrderLength = cancelableOrders.length;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
        );
      }
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          switch (mode) {
            case "distributionPrint":
              this.$router.push({
                path: "/print/orders-distribution-print",
                query: options,
              });
              break;
            case "OrdersPrint":
              this.$router.push({
                path: "/print/orders-print/",
                query: options,
              });
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          if (mode == "order") {
            //获取单据详情
            Orders.ordersPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let orders = response.data.orders;
                  CloudPrintTemplates.batchPrint({
                    print_template_code: mode,
                    objects: orders,
                  });
                }
              }.bind(this)
            );
          } else if (mode == "distribution") {
            //获取单据详情
            Orders.ordersToDistributionPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let orders = response.data.orders;
                  if (orders) {
                    let distributions = [];
                    orders.forEach((order) => {
                      if (order.distributions) {
                        order.shop = this.$printUtils.addCitiesName(order.shop);
                        order.distributions.forEach((distribution) => {
                          let printData = {
                            order: order,
                            distribution: makeData.processDetails(distribution),
                            order_address: distribution.order_address,
                          };
                          if (
                            printData.distribution &&
                            printData.distribution.stock_id
                          ) {
                            printData.stock_id =
                              printData.distribution.stock_id;
                          }
                          distributions.push(printData);
                        });
                      }
                    });
                    CloudPrintTemplates.batchPrint({
                      print_template_code: mode,
                      objects: distributions,
                    });
                  }
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    batchConfirm(options) {
      if (this.error_order_id.length) {
        options.no_order_ids = this.error_order_id;
      }
      Orders.batchConfirm(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.confirm_flg) {
              ++this.successCount;
            } else {
              if (
                response.data.errorCode &&
                response.data.errorCode == "ERR759"
              ) {
                ++this.redeliverErrorCount;
              } else {
                this.error_order_id.push(response.data.order_id);
                ++this.errorCount;
              }
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_order_id.push(response.data.order_id);
              ++this.errorCount;
            } else {
              this.getOrdersFromAPI();
              options = null;
              this.error_order_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.redeliverErrorCount = 0;
              this.alreadyConfirmedOrderLength = 0;
              this.batchConfirmingInfoDialog = false;
              this.$store.commit("refreshToDos", true);
            }
          }
          //去除本次作废的单子
          this.unconfirmOrders.splice(0, 1);
          //实时计数
          this.batchConfirmingInfo = i18n.t(
            "Order.messages.batchConfirmingInfo",
            [this.successCount, this.errorCount, this.redeliverErrorCount]
          );
          ++this.alreadyConfirmedOrderLength; //计已作废的单子总数
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchConfirm(options);
          }
        }.bind(this)
      );
    },
    batchCancel(options) {
      if (this.error_order_id.length) {
        options.no_order_ids = this.error_order_id;
      }
      Orders.batchCancel(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.cancel_flg) {
              ++this.successCount;
            } else {
              this.error_order_id.push(response.data.order_id);
              ++this.errorCount;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_order_id.push(response.data.order_id);
              ++this.errorCount;
            } else {
              this.getOrdersFromAPI();
              options = null;
              this.error_order_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.alreadyCanceledOrderLength = 0;
              this.batchCancelInfoDialog = false;
              this.$store.commit("refreshToDos", true);
            }
          }
          //去除本次作废的单子
          this.cancelableOrders.splice(0, 1);
          //实时计数
          this.batchCancelInfo = i18n.t("Order.messages.batchCancelInfo", [
            this.successCount,
            this.errorCount,
          ]);
          ++this.alreadyCanceledOrderLength; //计已作废的单子总数
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchCancel(options);
          }
        }.bind(this)
      );
    },
    batchApprove(options) {
      if (this.error_order_id.length) {
        options.no_order_ids = this.error_order_id;
      }
      Orders.batchApprove(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.approve_flg) {
              ++this.successCount;
            } else {
              this.error_order_id.push(response.data.order_id);
              ++this.errorCount;
              // this.batchApproveErrorData.push(response.data.data[0]);
              // this.batchApproveErrorDialog = true;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_order_id.push(response.data.order_id);
              ++this.errorCount;
              if (response.data.error.code == "ERR668") {
                this.batchApproveErrorData.push(response.data.data[0]);
                this.batchApproveErrorDialog = true;
              }
            } else {
              this.getOrdersFromAPI();
              options = null;
              this.error_order_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.alreadyApprovedOrderLength = 0;
              this.batchApproveInfoDialog = false;
              this.$store.commit("refreshToDos", true);
            }
          }
          //去除本次审批的单子
          this.approvableOrders.splice(0, 1);
          //实时计数
          this.batchApproveInfo = i18n.t("Order.messages.batchApproveInfo", [
            this.successCount,
            this.errorCount,
          ]);
          ++this.alreadyApprovedOrderLength; //计已审批的单子总数
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchApprove(options);
          }
        }.bind(this)
      );
    },
    importExcel() {
      Orders.importFiles(
        this.import_type,
        this.selectShop ? this.selectShop.id : "",
        this.import_type == 2 ? this.excelByBuyerFile : this.excelFile
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.info(
              i18n.t("Import.success", [i18n.t("Order.title")])
            );
            this.import_type == 2
              ? (this.ImportByBuyerDialog = false)
              : (this.ImportDialog = false);
            //刷新列表
            this.getOrdersFromAPI();
          } else if (this.import_type == 1 || this.import_type == 4) {
            this.errorOrders = response.data.orders;
            // this.errorOrders = Object.keys(orders).map(function(key){
            //   return {
            //     no: key,
            //     ext_code: orders[key].ext_code,
            //     actual_date: orders[key].actual_date,
            //     shop_code: orders[key].shop_code,
            //     order_details: orders[key].order_details[0],
            //     error_code: orders[key].error_code,
            //     error_msg: orders[key].error_msg
            //   };
            // });

            this.ImportDialog = false;
            this.ImportOrdersResultDialog = true;
          }
        }.bind(this)
      );
    },
    batchExport() {
      Orders.batchDetailExport(this.options);
    },
    freightExport() {
      Orders.freightExport(this.options);
    },
    setEditExpressFlg(data) {
      if (this.editExpressData && this.editExpressData.id != data.id) {
        // 未保存且切换待修改单据时
        this.orders = this.orders.map((order) => {
          if (order.id == this.editExpressData.id) {
            order.express_price = this.editExpressData.express_price;
          }
          return order;
        })
      }
      this.editExpressData = Object.assign({}, data);
    },
    saveExpress(data) {
      if (data.express_price < 0) {
        this.$snackbar.error(i18n.t("Order.messages.editExpressPriceError"));
        return;
      }
      Orders.saveExpress({
        id: data.id,
        express_price: data.express_price,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getOrdersFromAPI();
          }
        }.bind(this)
      );
    }
  },
};
</script>